import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SectionDetails } from '../styles';
import QandaItem from './qanda-item';
import Compliance from './compliance';

const Container = styled(SectionDetails)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: -60px;
  width: 100%;
`;

const none = -1;
export default function Details({ fund, qandas }) {
  const [opened, setOpened] = React.useState(none);
  const orderedQandas = _.sortBy(qandas, ['order']);

  const toggle = (expanded, i) => setOpened(expanded ? i : none);

  return (
    <Container>
      {orderedQandas.map((qanda, i) => (
        <QandaItem
          {...qanda}
          key={qanda.id}
          fundId={fund.id}
          expanded={opened === i}
          onToggle={v => toggle(v, i)}
        />
      ))}
      <Compliance fund={fund} />
    </Container>
  );
}

Details.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    qandasUpdatedAt: PropTypes.string,
  }).isRequired,
  qandas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    order: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    questionId: PropTypes.number.isRequired,
    answer: PropTypes.string.isRequired,
  })).isRequired,
};
